import React from 'react';
export function FormPageShimmer() {
  return <div className="space-y-6 animate-pulse" data-id="element-2263">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-2264">
        <div className="h-6 w-48 bg-gray-200 rounded" data-id="element-2265" />
        <div className="flex gap-2" data-id="element-2266">
          <div className="h-10 w-24 bg-gray-200 rounded-md" data-id="element-2267" />
          <div className="h-10 w-24 bg-gray-200 rounded-md" data-id="element-2268" />
        </div>
      </div>
      {/* Form card */}
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2269">
        <div className="space-y-6" data-id="element-2270">
          {/* Form sections */}
          {[1, 2].map(section => <div key={section} className="space-y-4" data-id="element-2271">
              <div className="h-5 w-32 bg-gray-200 rounded mb-4" data-id="element-2272" />
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2273">
                {[1, 2, 3, 4].map(i => <div key={i} data-id="element-2274">
                    <div className="h-4 w-24 bg-gray-200 rounded mb-2" data-id="element-2275" />
                    <div className="h-10 w-full bg-gray-200 rounded-md" data-id="element-2276" />
                  </div>)}
              </div>
            </div>)}
          {/* Text area */}
          <div data-id="element-2277">
            <div className="h-4 w-24 bg-gray-200 rounded mb-2" data-id="element-2278" />
            <div className="h-32 w-full bg-gray-200 rounded-md" data-id="element-2279" />
          </div>
          {/* Action buttons */}
          <div className="flex justify-end gap-2 pt-4 border-t border-gray-200" data-id="element-2280">
            <div className="h-10 w-24 bg-gray-200 rounded-md" data-id="element-2281" />
            <div className="h-10 w-32 bg-gray-200 rounded-md" data-id="element-2282" />
          </div>
        </div>
      </div>
    </div>;
}